import LegalLayout from "@/pages/LegalLayout";

export default function CerezPolitikasi() {
  return (
    <LegalLayout title="Çerez Politikası">
      <p className="text-sm text-zinc-500">
        Son güncelleme: {new Date().toLocaleDateString("tr-TR")}
      </p>

      <h2>Çerez Nedir?</h2>
      <p>
        Çerezler, ziyaret ettiğiniz web sitelerinin tarayıcınıza kaydettiği
        küçük metin dosyalarıdır. Uygulama'nın çalışması, kimlik doğrulama ve
        güvenlik amaçları için kullanılırlar.
      </p>

      <h2>Kullandığımız Çerezler</h2>
      <p>
        Kolay Arşivim <strong>yalnızca zorunlu (functional) çerezler</strong>
        kullanır. Analitik, pazarlama, izleme veya üçüncü taraf çerezi
        kullanmıyoruz.
      </p>

      <div className="not-prose border border-zinc-200 rounded-sm overflow-hidden my-6">
        <table className="w-full text-sm">
          <thead className="bg-zinc-50 text-zinc-700 text-xs uppercase tracking-wide">
            <tr>
              <th className="px-4 py-2 text-left">Çerez</th>
              <th className="px-4 py-2 text-left">Amaç</th>
              <th className="px-4 py-2 text-left">Süre</th>
              <th className="px-4 py-2 text-left">Tip</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-100">
            <tr>
              <td className="px-4 py-2 font-mono text-xs">access_token</td>
              <td className="px-4 py-2 text-zinc-700">
                Oturum yönetimi (JWT). HttpOnly, Secure, SameSite=Lax.
              </td>
              <td className="px-4 py-2 text-zinc-700">7 gün</td>
              <td className="px-4 py-2">
                <span className="rounded-sm bg-emerald-100 text-emerald-800 px-2 py-0.5 text-xs font-semibold">
                  Zorunlu
                </span>
              </td>
            </tr>
            <tr>
              <td className="px-4 py-2 font-mono text-xs">cookie_consent</td>
              <td className="px-4 py-2 text-zinc-700">
                Çerez bildirimi tercihinizi hatırlar (localStorage).
              </td>
              <td className="px-4 py-2 text-zinc-700">1 yıl</td>
              <td className="px-4 py-2">
                <span className="rounded-sm bg-emerald-100 text-emerald-800 px-2 py-0.5 text-xs font-semibold">
                  Zorunlu
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2>Çerezleri Yönetme</h2>
      <p>
        Tarayıcı ayarlarınızdan çerezleri silebilir veya engelleyebilirsiniz. Ancak
        zorunlu çerezler devre dışı bırakıldığında Uygulamaya giriş yapamayabilir
        ve ekspertiz kayıtlarınıza erişemeyebilirsiniz.
      </p>

      <h2>Değişiklikler</h2>
      <p>
        Çerez politikasında değişiklik olursa bu sayfa güncellenir. Son
        güncelleme tarihini yukarıda bulabilirsiniz.
      </p>
    </LegalLayout>
  );
}
